/**
 * Who is signed in, as far as this device knows — a non-secret hint, never a credential.
 *
 * The session is an httpOnly cookie this code cannot read (ADR-0008), so the only way to know
 * who is signed in is to ask the server. That is right, and it leaves two things the app needs
 * *without* asking: which account wrote a ball (so a second scorer on a shared phone cannot
 * push the first one's balls under their own account), and who to show as signed in when there
 * is no signal.
 *
 * This holds the account's id only. Nothing in it grants access to anything; reading it gives
 * an attacker a user id and nothing to use it with.
 */

let current: string | null = null;

/** The signed-in account's id, or null when unknown. Read by the store to tag each ball. */
export const currentUserId = (): string | null => current;

/** Set after `me()` answers, after signing in, and after signing out (null). */
export function setCurrentUserId(id: string | null): void {
  current = id;
}
